import * as React from 'react'

const SvgTimerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.375 6.875h1.25V12.5h-1.25V6.875zM8.125 1.25h3.75V2.5h-3.75V1.25zM17.5 5.625l-.887-.881-1.407 1.406a6.837 6.837 0 10.738 1.031L17.5 5.625zM10 16.25A5.625 5.625 0 1110 5a5.625 5.625 0 010 11.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgTimerIcon
